import React from 'react';
import Link from 'next/link';

import { jobPageUrlBuilder } from 'src/utils/url';
import style from './Jobs.module.scss';
import useLocale from '../../locales';

function JobsList({ jobsList, lang }) {
  return (
    <ul className="m-t-2 m-b-2 p-l-1 p-r-1 col-12">
      {jobsList.map((job) => (
        <List
          key={job.shortcode || job.id}
          id={job.shortcode || job.id}
          title={job.title}
          department={job.department?.name}
          city={job.location?.city?.name}
          lang={lang}
        />
      ))}
    </ul>
  );
}

function List({ title, department, city, id, lang }) {
  const { jobs } = useLocale(lang);
  const href = jobPageUrlBuilder({ title, lang, token: id });

  return (
    <li className="row">
      <div className="col-8 col-md-10">
        <h3>{title}</h3>
        {city && <span className={style['meta-info']}>{city} | </span>}
        <span className={style['meta-info']}>{department}</span>
      </div>
      <div
        className={`col-4 col-md-2 text-right  text-sm-center${style['btn-wrapper']}`}>
        <Link href="/positions/[lang]/[id]" as={href}>
          <a className={`btn ${style.btn}`}>{jobs.button}</a>
        </Link>
      </div>
    </li>
  );
}

export default JobsList;
